@if (showLanguageSelect) {
<div #langSelect class="jeopardy-lang-selection select-language" style="text-align: -webkit-center;"
  [@fadeInOnEnter]="{value: '', params: { duration: fadeInDuration }}"
  [@fadeOutOnLeave]="{value: '', params: { duration: fadeOutDuration }}"
  (@fadeOutOnLeave.done)="showCountryForm($event)">
  <h2>{{i18n.str('challengeu.select_language_your_language','What is your language?')()}}</h2>
  <br><br>
  <div class="lang-container">
    <a class="lang-arrow left" [class.disabled]="langIndex() === 0" href="#" (click)="skipLanguage($event, 'left')" title="Click to shift the list of languages to the left"></a>
    <ul class="lang-wrapper">
      @for (lang of languages(); track lang.isoCode2Letters; let i = $index) {
      <li #lang [class.active]="langSelected()?.isoCode2Letters === lang.isoCode2Letters" (click)="pickLanguage(i)">
        <div class="code">
          {{lang.isoCode2Letters| uppercase}}
        </div>
        <br>
        <div class="name">
          {{lang.name}}
        </div>
      </li>
      }
    </ul>
    <a class="lang-arrow right" [class.disabled]="langIndex() === (languages().length - 1)" href="#"
      (click)="skipLanguage($event, 'right')" title="Click to shift the list of languages to the right"></a>
  </div>
  <p class="jeopardy-button primary" [class.disabled]="!langSelected()">
    <a href="#" (click)="confirmLanguage($event)"
      (touchend)="confirmLanguage($event)">{{i18n.str('challengeu.dialog_ok','OK')()}}</a>
  </p>
</div>
}

@if (showCountrySelect) {
<div #countrySelect class="jeopardy-lang-selection select-country" style="text-align: -webkit-center;"
  [@fadeInOnEnter]="{value: '', params: { duration: fadeInDuration }}"
  [@fadeOutOnLeave]="{value: '', params: { duration: fadeOutDuration }}"
  (@fadeOutOnLeave.done)="showUserDetailsForm($event)">
  <form class="frmCountry">
    <h2>{{i18n.str('challengeu.select_language_where_from', 'Where are you from?')()}}</h2>
    <br>
    <input [(ngModel)]="countryInput" [ngModelOptions]="{standalone: true}" type="text"
      [placeholder]="i18n.str('challengeu.select_language_country_placeholder','I am from')()"
      (blur)="i18n.str('challengeu.select_language_country_placeholder','I am from')()"
      (focus)="''">
    <div class="suggestion-list">
      @for (item of filteredCountries(); track item) {
      <a href="#" class="neon-yellow" (click)="selectCountry($event, item)">{{item.value}}</a>
      }
    </div>
  </form>
  @if (countrySelected()) {
  <h2>{{i18n.str('challengeu.select_language_your_country','Your country is:')()}}</h2>
  }
  @if (countrySelected()) {
  <h3 #selectedCountry> {{countrySelected()?.value | uppercase}}</h3>
  }
  <p class="jeopardy-button primary" [class.disabled]="countryInput() && !countrySelected()">
    <a href="#" (click)="confirmCountry($event)">{{i18n.str('challengeu.dialog_ok','OK')()}}</a>
  </p>
</div>
}

@if (showUserDetails) {
<app-user-details></app-user-details>
}
